import React, { useState } from 'react';

import { ErrorMessage } from '@hookform/error-message';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import {apollo_useStyles} from "./Apollo_styles";

interface acountinerface {
    register : any;
    errors: any;
}

export const ApolloAccount : React.FC<acountinerface> = (props) => {

    const classes = apollo_useStyles();

    return (<div>
        <FormControl className={classes.form} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">メールアドレス</InputLabel>
            <OutlinedInput
                id="email"
                type='text'
                required
                fullWidth
                label="eメールアドレス"
                name="email"
                autoComplete="off"
                inputRef={props.register({
                    required: 'メールアドレスは必ず入力してください。',
                    pattern: {
                        value: /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                        message: '正しいメールアドレス形式を入力してください。'
                    }
                })}

            />
        </FormControl>
        <ErrorMessage errors={props.errors } name="email" />
    </div>)
}